import React from 'react';
import OrderStyles from './OrderHistory.module.css';
import AppStyles from '../App/App.module.css';

import { useSelector, useDispatch } from "../../services/hooks";
import OrderItem from './OrderItem';

import { TCardData } from '../../types';
import { wsAuthConnectionClose, wsAuthConnectionStart } from '../../services/actions/wsAuthActions';

interface IOrderHistory {
  openModal: () => void;
}

const OrderHistory: React.FC<IOrderHistory> = (props) => {

  const dispatch = useDispatch();
  React.useEffect((): () => void => {
    dispatch(wsAuthConnectionStart());
    return () => dispatch(wsAuthConnectionClose());
  }, [dispatch])

  const orderFeed = useSelector(
    (state) => state.userOrderFeed
  );

  const burgerIngredientsArray = useSelector(
    (state) => state.burgerIngredients.burgerIngredientsArray
  );
  
  const orderFeedData = orderFeed.orderFeedData as { orders?: Array<TCardData> } | undefined;
  const orders: Array<TCardData> = orderFeedData && Array.isArray(orderFeedData.orders) ? orderFeedData.orders : [];

  if (orderFeed.isPageLoading === true || burgerIngredientsArray.length === 0) {
    return <div className={AppStyles.centeredComponent + " text text_type_main-large"}>Загрузка...</div>
  }

  if (orderFeed.wsError) {
    return <div className={AppStyles.centeredComponent + " text text_type_main-large"}>Не удалось загрузить историю заказов</div>
  }

  return (
    <div className={OrderStyles.orderHistory}>
      <ul className={OrderStyles.profileList}>
        {orders.map((card: TCardData, index: number) => (
          <OrderItem card={card} openModal={props.openModal} feed={true} key={index} isAuth={true} />
        ))}
      </ul>
    </div>
  );
}

export default OrderHistory;